import { render, staticRenderFns } from "./PeixunshiMemberList.vue?vue&type=template&id=2f1e34d7&scoped=true&"
import script from "./PeixunshiMemberList.vue?vue&type=script&lang=js&"
export * from "./PeixunshiMemberList.vue?vue&type=script&lang=js&"
import style0 from "./PeixunshiMemberList.vue?vue&type=style&index=0&id=2f1e34d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e34d7",
  null
  
)

export default component.exports